import Modal, {
  Appearance,
  ModalBody,
  ModalFooter,
  ModalHeader,
  ModalTitle,
  ModalTransition,
} from '@atlaskit/modal-dialog';
import React, { FC, useCallback } from 'react';
import { translationKeys, useTranslation } from 'services/localization';
import { selectConsentDeclinePrDialog } from '../../preferencesSelectors';
import { sendItemsFromUI, showConsentDeclinePrDialog } from '../../preferencesSlice';
import { trackConfirmConsentPrUnsubClick, trackDeclineConsentPrUnsubClick } from '../../services/userActionEvents';
import Button from '@atlaskit/button';
import { useAppDispatch, useAppSelector } from '../../../../hooks';

const ConsentDeclinePrDialog: FC = () => {
  const dispatch = useAppDispatch();
  const { translate } = useTranslation();
  const dialogPayload = useAppSelector(selectConsentDeclinePrDialog);

  const acceptHandler = useCallback(async () => {
    trackConfirmConsentPrUnsubClick({
      source: dialogPayload.update?.sourceItem,
      componentName: 'modal',
    });

    // send originating request
    if (dialogPayload.update !== null) dispatch(sendItemsFromUI(dialogPayload.update!));

    // close dialog
    dispatch(showConsentDeclinePrDialog({ showDialog: false }));
  }, [dispatch, dialogPayload]);

  const cancelHandler = useCallback(() => {
    trackDeclineConsentPrUnsubClick({
      source: dialogPayload.update?.sourceItem,
      componentName: 'modal',
    });

    // close dialog
    dispatch(showConsentDeclinePrDialog({ showDialog: false }));
  }, [dispatch, dialogPayload]);

  const actions = [
    {
      text: translate(translationKeys.CONSENT_DECLINE_PR_ACCEPT_BUTTON_LABEL),
      onClick: acceptHandler,
      autoFocus: true,
      appearance: 'warning' as Appearance,
      testId: 'consent-decline-pr-accept-button',
    },
    {
      text: translate(translationKeys.CONSENT_DECLINE_PR_CANCEL_BUTTON_LABEL),
      onClick: cancelHandler,
      appearance: 'subtle' as Appearance,
      testId: 'consent-decline-pr-cancel-button',
    },
  ];

  return (
    <ModalTransition>
      {dialogPayload.showDialog && (
        <Modal onClose={cancelHandler} testId='consentDeclinePr'>
          <ModalHeader>
            <ModalTitle appearance={'warning'}>{translate(translationKeys.CONSENT_DECLINE_PR_DIALOG_LABEL)}</ModalTitle>
          </ModalHeader>
          <ModalBody>
            <p dangerouslySetInnerHTML={{ __html: translate(translationKeys.CONSENT_DECLINE_PR_DIALOG_MESSAGE) }} />
          </ModalBody>
          <ModalFooter>
            {actions.map((a) => (
              <Button
                key={a.testId}
                appearance={a.appearance}
                onClick={a.onClick}
                autoFocus={a.autoFocus}
                testId={a.testId}
              >
                {a.text}
              </Button>
            ))}
          </ModalFooter>
        </Modal>
      )}
    </ModalTransition>
  );
};

export default ConsentDeclinePrDialog;
